import addAlertMessage from './add-alert-message'

export default addAlertMessage
